export const FETCH_E2E_NOTIFICATIONS = 'FETCH_E2E_NOTIFICATIONS';
export const FETCH_E2E_NOTIFICATIONS_SUCCESS = 'FETCH_E2E_NOTIFICATIONS_SUCCESS';
export const FETCH_E2E_NOTIFICATIONS_FAILURE = 'FETCH_E2E_NOTIFICATIONS_FAILURE';

export const UPDATE_E2E_NOTIFICATION_FLAG = 'UPDATE_E2E_NOTIFICATION_FLAG';
export const UPDATE_E2E_NOTIFICATION_FLAG_SUCCESS = 'UPDATE_E2E_NOTIFICATION_FLAG_SUCCESS';
export const UPDATE_E2E_NOTIFICATION_FLAG_FAILURE = 'UPDATE_E2E_NOTIFICATION_FLAG_FAILURE';
